/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Link/theme';

export const LinkTheme = theme;
